var $ = jQuery;

$(document).ready(function ($) {
    //header scroll
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 2) {
            $("header").addClass("scrolling");
        } else {
            $("header").removeClass("scrolling");
        }
    });

    //link hover effects
    var $header = $('#header');

    $header.find('a').hover(
        function () {
            var scroll = $(window).scrollTop();
            // Add scrolling class only if the user is at the top, header has `transparent` class, and does NOT have `mobile-menu-open`
            if (
                scroll < 2 &&
                $header.hasClass('transparent') &&
                !$header.hasClass('mobile-menu-open') &&
                !$header.hasClass('scrolling')
            ) {
                $header.addClass('scrolling');
            }
        },
        function () {
            var scroll = $(window).scrollTop();
            // Remove scrolling class only when 'focused' class is not present, `transparent` is still there, and `mobile-menu-open` is absent
            if (
                scroll < 2 &&
                $header.hasClass('transparent') &&
                !$header.hasClass('mobile-menu-open')
            ) {
                const checkAndRemoveScrolling = () => {
                    if (!$header.hasClass('focused')) {
                        $header.removeClass('scrolling');
                    } else {
                        // Check again after a short delay
                        setTimeout(checkAndRemoveScrolling, 800);
                    }
                };
                checkAndRemoveScrolling();
            }
        }
    );
});

/// colours change on hover
$(document).ready(function ($) {

    $("header ul.nav a").on("mouseover", function () {
        $(this).addClass('focused-active');
        var colour = $(this).attr('data-colours');
        $('header').addClass('logo-' + colour + ' focused');
    }).mouseleave(function () {
        $(this).removeClass('focused-active');
        if (!$('.sub-nav-container-outer').hasClass('open')) {
            var colour = $(this).attr('data-colours');
            $('header').removeClass('logo-' + colour + ' focused');
        } else {
            $('header').removeClass('focused');
        }
    });
});


$(document).ready(function ($) {

    //const breakpoint = 1023;
    const breakpoint = 1000;

    var navTimeout = setInterval(function () {
        close_sub_nav(breakpoint);
    }, 400);

    $(".main-menu li.has-sub-nav > a").hover(function () {

        clearInterval(navTimeout);

        if ($(window).width() > breakpoint) {

            sub_nav_container_outer = $('.sub-nav-container-outer');
            sub_nav_container = $('.sub-nav-container');
            target_nav = $(this).attr('data-target-nav');
            target_nav_height = $('.sub-nav-' + target_nav).height();

            $(".main-menu li.has-sub-nav").each(function () {
                $(this).removeClass('active')
            });

            $('.sub-nav-container .sub-nav').each(function () {
                $(this).removeClass('active')
            });

            if (!sub_nav_container_outer.hasClass('open')) {
                $('.sub-nav-' + target_nav).addClass('active');
                sub_nav_container.height(target_nav_height + 'px');
                sub_nav_container_outer.addClass('open');

            } else {
                $('.sub-nav-' + target_nav).addClass('active');
                sub_nav_container.height(target_nav_height + 'px');
                sub_nav_container_outer.addClass('open');
            }

            /// set logo colour
            var colour = $(this).attr('data-colours');
            $('header').addClass('logo-' + colour + ' focused');

            $(this).parent('li.has-sub-nav').addClass('active');
            //$('header').addClass('focused');
        }

    }, function () {
        navTimeout = setInterval(function () {
            close_sub_nav(breakpoint);
        }, 400);
    });

    $("header.header-mega_menu .sub-nav-container-inner").hover(function () {
        $('header').addClass('focused');
        clearInterval(navTimeout);
    }, function () {
        $('header').removeClass('focused');
        navTimeout = setInterval(function () {
            close_sub_nav(breakpoint);
        }, 400);
    });

});

function close_sub_nav(breakpoint) {

    if ($(window).width() > breakpoint) {

        if ($("header.header-mega_menu .sub-nav-container-outer").hasClass('open')) {

            //$('header.header-mega_menu').removeClass('focused');

            $("header.header-mega_menu .main-menu li.has-sub-nav").each(function () {
                if ($(this).hasClass('active')) {
                    var colour = $(this).find('a').attr('data-colours');
                    $('header').removeClass('logo-' + colour);
                    $(this).removeClass('active')
                }
            });

            $('header.header-mega_menu .sub-nav-container .sub-nav').each(function () {
                $(this).removeClass('active');
            });


            $('header.header-mega_menu .sub-nav-container').height('0px');
            $('header.header-mega_menu .sub-nav-container-outer').removeClass('open');
        }
    }
}


$(document).ready(function () {
    $(window).on("resize", function () {
        if ($(window).width() > '1024') {
            var nav_container = $('.sub-nav-container-outer');
            set_resized_nav_height = nav_container.find('.sub-nav.active').height();
            if (nav_container.hasClass('open')) {
                $('.sub-nav-container').height(set_resized_nav_height);
            }
        }
    });
});


$(function ($) {

    $('header .country-select-container a:not(.active)').on('click', function (e) {

        const redirct_url = $(this).attr('data-lang-url');
        const lang_code = $(this).attr('data-lang-code');

        if (redirct_url.length) {

            if ($.cookie('kinesis_location_data') != null) {
                //cookie already exists
                var old_cookie = $.parseJSON($.cookie('kinesis_location_data'));

                $.each(old_cookie, function (index, value) {
                    if (index == 'preferred_country_code') {
                        old_cookie.preferred_country_code = lang_code;
                    }

                });

                $.cookie('kinesis_location_data', JSON.stringify(old_cookie), {
                    expires: 365,
                    path: '/'
                });
            }
            window.location.href = redirct_url;
        }
    });
});